import { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

function QuickNav() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button if not at bottom
      const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;
      setShowButton(!isAtBottom && window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!showButton) return null;

  return (
    <div className="md:hidden fixed bottom-[232px] right-4 z-40 flex flex-col gap-2">
      <button
        onClick={scrollToTop}
        className="bg-white/90 backdrop-blur border-2 border-[#006847] text-[#006847] p-2.5 rounded-full shadow-lg hover:bg-[#006847] hover:text-white transition"
        aria-label="Scroll to top"
      >
        <ChevronUp className="h-4 w-4" />
      </button>
      <button
        onClick={scrollToBottom}
        className="bg-[#006847] text-white p-2.5 rounded-full shadow-lg hover:bg-[#005a3c] transition"
        aria-label="Scroll to bottom"
      >
        <ChevronDown className="h-4 w-4" />
      </button>
    </div>
  );
}

export default QuickNav;
